export const salutationsConstants = {
	de: [
		{ label: 'Keine', value: '0' },
		{ label: 'Frau', value: '1' },
		{ label: 'Herr', value: '2' },
		{ label: 'Divers', value: '3' }
	],

	en: [
		{ label: 'none', value: '0' },
		{ label: 'Ms.', value: '1' },
		{ label: 'Mr.', value: '2' },
		{ label: 'Mx.', value: '3' }
	]
};
